import React from "react";
import Chart from "react-apexcharts";
import { observer } from "mobx-react";
import { toJS } from "mobx";

import { Common_Utils } from "qubit-utill/src";

import UISET from "@src/constants/uiset";
import NullLogData from "@src/common/components/organisms/Graphs/NullLogData";

//추가옵션
interface GraphOptionPropsTypes {
  legend?: { horizontalAlign: string };
  plotOptions?: { pie: any };
}
interface PropsTypes {
  id: string;
  title: string;
  data: number[];
  category: string[];
  valueFormater?: Function;
  height?: number;
  graphOption?: GraphOptionPropsTypes;
}

const Donut: React.FC<PropsTypes> = ({ id, title, data, category, valueFormater, height = 250, graphOption }) => {
  const _valueFormater = (value) => (valueFormater ? valueFormater(value) : Common_Utils.numberWithComma(value));

  const series = data && data.length > 0 ? toJS(data) : [];

  const options = {
    title: { text: title, align: "center" as const },
    labels: category && category.length > 0 ? toJS(category) : [],

    chart: {
      id: id,
      toolbar: {
        show: false,
      },
      redrawOnParentResize: true,
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: function(value, opts) {
          return opts.globals.seriesPercent[opts.seriesIndex][0].toFixed(2) + `% (${_valueFormater(value)})`;
        },
      },
    },
    dataLabels: {
      enabled: false,
      formatter: function(val, opts) {
        const name = opts.w.globals.labels[opts.seriesIndex];
        return name.concat(`${val.toFixed(2)}%`);
      },
    },
    legend: {
      show: true,
      position: "bottom" as const,
      horizontalAlign: (graphOption?.legend?.horizontalAlign as any) || ("center" as const),
      itemMargin: {
        // horizontal: 0,
        vertical: 0,
      },
      formatter: function(seriesName, opts) {
        const percent = opts.w.globals.seriesPercent[opts.seriesIndex];
        return seriesName.concat(` (${percent && percent[0].toFixed(2)}%)`);
      },
    },
    plotOptions: graphOption?.plotOptions?.pie || {
      pie: {
        donut: {
          labels: {
            show: false,
          },
        },
      },
    },
    colors: UISET.CHART_COLOR,
  };

  return data && data.length > 0 ? (
    <Chart options={options} series={series} type="donut" height={`${height}px`} />
  ) : (
    <NullLogData />
  );
};

export default observer(Donut);
